import "./Header.scss";

function Header() {
  return (
    <header className="main-header">
      <div className="container">
        <h1 className="main-header__title">Book Extracts from Pan Macmillan</h1>
        <p className="main-header__description">
          Browse and read book extracts from Pan Macmillan site
        </p>
      </div>
    </header>
  );
}

export default Header;
